@use '../../design-tokens/typography/typography' as *;

@layer design-system {
  .barChartRoot {
    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative;
  }

  .header {
    margin-bottom: 12px;
  }

  .title {
    @include typography-v2-title-base;
  }

  .titleUnderline {
    display: inline-block;
    text-decoration: underline dashed;
    text-underline-offset: 6px;
    text-decoration-thickness: 1px;
    text-decoration-color: var(--border-default);
  }

  .axisLine {
    stroke-width: 1px;
    stroke: var(--border-soft);
  }

  .axisLineHighlight {
    stroke: var(--border-default);
  }

  .axisText {
    color: var(--text-default);
    font-size: 12px;
    fill: var(--text-default);
  }

  .labelAxisY {
    font-family: var(--font-roboto-mono);
  }

  .titleAxisY {
    color: var(--text-default);
    font-family: var(--font-roboto-mono);
    @include typography-v2-body-sm;
    text-align: right;
    padding-right: 35px;
    padding-bottom: 8px;
  }

  .labelAxisX {
    transform: translateY(-8px);
  }

  .svgBlurred {
    filter: blur(1px);
  }

  .errorMessageWrapper {
    position: absolute;
    inset: 0;
    background: rgba(var(--background-default-rgb), 0.5);
    z-index: 1;

    [data-error-message] {
      width: calc(100% - 50px);
      margin: 0;
    }
  }

  .legendWrapper {
    position: relative;
    z-index: 2;
  }
}
